<div class="min-h-screen flex flex-col justify-between">
  <main class="flex-1 flex flex-col">
    <router-outlet />
  </main>
</div>
